import axios from 'axios';
import { getListModel } from '@/utils/customizer';
import { getUrlParams } from '@/utils/url';

export default {
  setMaterialItem({ commit, state }) {
    let index = -1;

    if (state.queryParams.model.material) {
      index = state.materials.findIndex(
        el => el.material?.vendor_code === state.queryParams.model.material,
      );
    }

    if (index !== -1) {
      commit('updateMaterialsItem', state.materials[index]);
    } else {
      // commit('updateMaterialsItem', state.materials[0]);
    }
  },

  setHeightFromModelPrice({ commit, getters }) {
    if (getters.getModelPrice) {
      commit('updateModelSizeHeight', 1000);
    }
  },

  setModelFromBasket(
    { commit, dispatch, state, getters },
    { system, model, material, width, height },
  ) {
    commit('updateModelSizeHeight', '');
    commit('updateModelSizeWidth', '');

    const systemIndexFind = state.models?.findIndex(({ id = '' }) => id === system?.id);

    if (systemIndexFind !== -1) {
      commit('updateSystem', systemIndexFind);
      const systemItem = state.models[systemIndexFind];

      const modelFindIndex = systemItem?.models?.findIndex(({ id = '' }) => id === model?.id);
      if (modelFindIndex !== -1) {
        commit('updateModel', modelFindIndex);

        const modelItem = systemItem.models[modelFindIndex];

        if (modelItem?.sub_models?.length > 0) {
          const subModelFind = modelItem.sub_models.find(
            ({ id = '' }) => id === model?.sub_model?.id,
          );

          if (subModelFind) {
            commit('updateSubModel', subModelFind.id);
          }
        }
      }
    }

    const currentModelId = model?.id;

    if (currentModelId) {
      dispatch('loadMaterials', { id: currentModelId }).then(res => {
        const materialFind = res.find(item => item?.material?.id === material?.id);
        if (materialFind) {
          commit('updateMaterialsItem', materialFind);
        }

        commit('updateModelSizeHeight', height);
        commit('updateModelSizeWidth', width);
      });
    }

    return new Promise(res => res({ currentModelId }));
  },

  loadModels({ commit, dispatch, state }, params) {
    const urlParamsString = location?.search || '';
    const urlParams = getUrlParams(urlParamsString);
    // скрывает все системы кроме предвыбранной
    const ho = urlParams.get('ho');

    return new Promise((resolve, reject) => {
      let query = params ? `?view=${params}` : '';

      axios.get(`${process.env.VUE_APP_API_URL}/api/models${query}`).then(
        res => {
          const itemSelectedFind = res.data.find(el => el.selected);
          const data = ho ? (itemSelectedFind ? [itemSelectedFind] : res.data) : res.data;

          // если в системе нету моделей, то такая система нам не важна
          const currentData = data.filter(({ models = [] }) => models.length > 0);

          commit('updateModels', currentData);
          const systemIndex = currentData.findIndex(el => el.selected);

          if (systemIndex !== -1) {
            commit('updateQueryParamsSystem', systemIndex);
            commit('updateSystem', systemIndex);

            const models = state.models[systemIndex].models;
            const modelIndex = models.findIndex(el => el.selected);

            if (modelIndex !== -1) {
              const listModel = getListModel(models);
              const modelItem = models[modelIndex];
              const modelItemId = modelItem.id;
              const listModelFind = listModel.find(
                ({ id, items = [] }) =>
                  id === modelItemId || items.find(({ id }) => id === modelItemId),
              );

              commit('updateQueryParamsModel', modelIndex);
              const subModels = listModelFind?.items;

              if (subModels?.length) {
                const subModelFind = subModels.find(({ selected }) => selected);

                if (subModelFind) {
                  commit('updateModel', modelIndex);
                  commit('updateSubModel', subModelFind.id);
                } else {
                  commit('updatePreselectedModel', modelItem);
                  commit('updateIsTriggerModelPopover', true);
                }
              } else {
                commit('updateModel', modelIndex);
              }
            }

            dispatch('options/setOptionsList', '', { root: true });
          }

          resolve(currentData);
        },
        error => {
          reject(error);
        },
      );
    });
  },

  loadMaterials({ commit, state }, params) {
    const materialsItem = state.materialsItem;
    commit('updateMaterialsItem', null);

    return new Promise((resolve, reject) => {
      axios.get(`${process.env.VUE_APP_API_URL}/api/models/${params.id}/materials`).then(
        res => {
          const list = res.data || [];

          commit('updateMaterials', list);
          const materialVendorCode = state.queryParams.model?.material;

          if (materialsItem?.material?.id) {
            const itemFind = list.find(item => item.material.id === materialsItem.material.id);

            commit('updateMaterialsItem', itemFind);
          } else if (materialVendorCode) {
            const materialFind = list.find(
              ({ material = null }) => material?.vendor_code === materialVendorCode,
            );

            commit('updateMaterialsItem', materialFind);
          }

          resolve(list);
        },
        error => {
          reject(error);
        },
      );
    });
  },
};
